import {IS_JAMPA} from "shared/api/client";

/**
 * מונחים שתלויים במותג. HK ו-Jampa הם אותו קוד ואותו בילד — הדגל IS_JAMPA נקבע לפי הדומיין
 * בזמן ריצה. במקום לפזר תנאים בכל מסך, כל מונח תלוי־תפקיד יושב כאן פעם אחת.
 *
 * ההקבלה: יועץ↔מטפל, חברה↔לקוח, ומי שמלווה את הלקוח ביום-יום —
 * אצלנו מנהל התזרים, ב-Jampa המטפל.
 */
export const terms = {
    /** מי מלווה את הלקוח ביום-יום. "מנהל התזרים" / "המטפל" */
    handler: IS_JAMPA ? "המטפל" : "מנהל התזרים",
    /** אותו תפקיד בצורת שייכות: "מנהל התזרים שלך" / "המטפל שלך" */
    handlerOfYours: IS_JAMPA ? "המטפל שלך" : "מנהל התזרים שלך",
    /** בעל התיק אצל היועץ. "חברה" / "לקוח" */
    account: IS_JAMPA ? "מטופל" : "חברה",
    /** ברבים: "חברות" / "מטופלים" */
    accountPlural: IS_JAMPA ? "מטופלים" : "חברות",
    /** פתיחת תיק חדש. "מטופל חדש" / "חברה חדשה" — התאמת מין, כמו באפליקציה */
    newAccount: IS_JAMPA ? "מטופל חדש" : "חברה חדשה",
    /** מי שמנהל את התיק. "יועץ" / "מטפל" */
    advisor: IS_JAMPA ? "מטפל" : "יועץ",
    advisorPlural: IS_JAMPA ? "מטפלים" : "יועצים",
    /** מיודע: "היועץ" / "המטפל" */
    advisorDef: IS_JAMPA ? "המטפל" : "היועץ",
    /** עם ל' השימוש: "ליועץ" / "למטפל" */
    advisorTo: IS_JAMPA ? "למטפל" : "ליועץ",
    /** מי שהיועץ מטפל בו — בהקשר אנושי (משימה, בקשה, שיחה), לא התיק עצמו.
        "לקוח" / "מטופל". לתיק עצמו — account. */
    client: IS_JAMPA ? "מטופל" : "לקוח",
    clientDef: IS_JAMPA ? "המטופל" : "הלקוח",
    clientTo: IS_JAMPA ? "למטופל" : "ללקוח",
    clientPlural: IS_JAMPA ? "מטופלים" : "לקוחות",
    /** "לחברה זו" / "למטופל זה" — התאמת מין */
    toThisAccount: IS_JAMPA ? "למטופל זה" : "לחברה זו",
    /** "לא נמצאה חברה מתאימה" / "לא נמצא מטופל מתאים" — התאמת מין */
    noMatchingAccount: IS_JAMPA ? "לא נמצא מטופל מתאים" : "לא נמצאה חברה מתאימה",
    /** שם מסך הזיכרון: "זיכרון החברה" / "זיכרון המטופל" */
    accountMemory: IS_JAMPA ? "זיכרון המטופל" : "זיכרון החברה",
    /** ללא ה"א הידיעה: "מנהל תזרים" / "מטפל" — לכותרות עמודה ולמצבים ריקים */
    handlerIndef: IS_JAMPA ? "מטפל" : "מנהל תזרים",
    /** ברבים ומיודע: "מנהלי התזרים" / "המטפלים" */
    handlerPlural: IS_JAMPA ? "המטפלים" : "מנהלי התזרים",
    /** עם ל' השימוש: "למנהל התזרים" / "למטפל" — ה"א הידיעה נבלעת */
    handlerTo: IS_JAMPA ? "למטפל" : "למנהל התזרים",
    /** סמיכות מיודעת: "חברת הייעוץ" / "הקליניקה" */
    firmDefinite: IS_JAMPA ? "הקליניקה" : "חברת הייעוץ",
    /** מי שמנהל את כל המערכת. אייל 08.09: ב-Jampa זה "מנהל Jampa" */
    systemAdmin: IS_JAMPA ? "מנהל Jampa" : "מנהל מערכת",
    /** המשרד שאליו שייך המטפל / היועץ */
    firm: IS_JAMPA ? "קליניקה" : "חברת ייעוץ",
    firmPlural: IS_JAMPA ? "קליניקות" : "חברות ייעוץ",
    /** רמז לשדה חיפוש התיקים. ח.פ קיים רק אצלנו — למטופל אין מספר חברה */
    accountSearchHint: IS_JAMPA ? "חיפוש מטופל" : "חיפוש חברה או ח.פ",
    /** שם המותג בטקסט: "HK" / "Jampa". אייל 24.10 (#924): בג׳אמפה לא מופיעה המילה HK. */
    brand: IS_JAMPA ? "Jampa" : "HK",
    /** שם המותג המלא בעמודים ציבוריים: "HK Money" / "Jampa" */
    brandProduct: IS_JAMPA ? "Jampa" : "HK Money",
    /** המסמך החי שלפני הפגישה. אייל 25.09: "הכנה לפגישה" בשני המותגים —
        "בריף" נשאר באפליקציה בלבד. */
    prep: "הכנה לפגישה",
} as const;
